import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::index
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:34
* @route '/room-types'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/room-types',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::index
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:34
* @route '/room-types'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::index
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:34
* @route '/room-types'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::index
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:34
* @route '/room-types'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::index
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:34
* @route '/room-types'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::index
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:34
* @route '/room-types'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::index
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:34
* @route '/room-types'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::create
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:128
* @route '/room-types/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/room-types/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::create
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:128
* @route '/room-types/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::create
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:128
* @route '/room-types/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::create
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:128
* @route '/room-types/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::create
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:128
* @route '/room-types/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::create
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:128
* @route '/room-types/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::create
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:128
* @route '/room-types/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::store
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:161
* @route '/room-types'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/room-types',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::store
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:161
* @route '/room-types'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::store
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:161
* @route '/room-types'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::store
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:161
* @route '/room-types'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::store
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:161
* @route '/room-types'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::show
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:84
* @route '/room-types/{roomType}'
*/
export const show = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/room-types/{roomType}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::show
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:84
* @route '/room-types/{roomType}'
*/
show.url = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { roomType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { roomType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            roomType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        roomType: typeof args.roomType === 'object'
        ? args.roomType.id
        : args.roomType,
    }

    return show.definition.url
            .replace('{roomType}', parsedArgs.roomType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::show
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:84
* @route '/room-types/{roomType}'
*/
show.get = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::show
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:84
* @route '/room-types/{roomType}'
*/
show.head = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::show
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:84
* @route '/room-types/{roomType}'
*/
const showForm = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::show
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:84
* @route '/room-types/{roomType}'
*/
showForm.get = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::show
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:84
* @route '/room-types/{roomType}'
*/
showForm.head = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::edit
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:215
* @route '/room-types/{roomType}/edit'
*/
export const edit = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/room-types/{roomType}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::edit
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:215
* @route '/room-types/{roomType}/edit'
*/
edit.url = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { roomType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { roomType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            roomType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        roomType: typeof args.roomType === 'object'
        ? args.roomType.id
        : args.roomType,
    }

    return edit.definition.url
            .replace('{roomType}', parsedArgs.roomType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::edit
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:215
* @route '/room-types/{roomType}/edit'
*/
edit.get = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::edit
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:215
* @route '/room-types/{roomType}/edit'
*/
edit.head = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::edit
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:215
* @route '/room-types/{roomType}/edit'
*/
const editForm = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::edit
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:215
* @route '/room-types/{roomType}/edit'
*/
editForm.get = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::edit
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:215
* @route '/room-types/{roomType}/edit'
*/
editForm.head = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::update
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:319
* @route '/room-types/{roomType}'
*/
export const update = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/room-types/{roomType}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::update
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:319
* @route '/room-types/{roomType}'
*/
update.url = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { roomType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { roomType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            roomType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        roomType: typeof args.roomType === 'object'
        ? args.roomType.id
        : args.roomType,
    }

    return update.definition.url
            .replace('{roomType}', parsedArgs.roomType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::update
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:319
* @route '/room-types/{roomType}'
*/
update.put = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::update
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:319
* @route '/room-types/{roomType}'
*/
const updateForm = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::update
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:319
* @route '/room-types/{roomType}'
*/
updateForm.put = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::togglePause
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:288
* @route '/room-types/{roomType}/toggle-pause'
*/
export const togglePause = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: togglePause.url(args, options),
    method: 'patch',
})

togglePause.definition = {
    methods: ["patch"],
    url: '/room-types/{roomType}/toggle-pause',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::togglePause
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:288
* @route '/room-types/{roomType}/toggle-pause'
*/
togglePause.url = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { roomType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { roomType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            roomType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        roomType: typeof args.roomType === 'object'
        ? args.roomType.id
        : args.roomType,
    }

    return togglePause.definition.url
            .replace('{roomType}', parsedArgs.roomType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::togglePause
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:288
* @route '/room-types/{roomType}/toggle-pause'
*/
togglePause.patch = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: togglePause.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::togglePause
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:288
* @route '/room-types/{roomType}/toggle-pause'
*/
const togglePauseForm = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: togglePause.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::togglePause
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:288
* @route '/room-types/{roomType}/toggle-pause'
*/
togglePauseForm.patch = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: togglePause.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

togglePause.form = togglePauseForm

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::destroy
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:363
* @route '/room-types/{roomType}'
*/
export const destroy = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/room-types/{roomType}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::destroy
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:363
* @route '/room-types/{roomType}'
*/
destroy.url = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { roomType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { roomType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            roomType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        roomType: typeof args.roomType === 'object'
        ? args.roomType.id
        : args.roomType,
    }

    return destroy.definition.url
            .replace('{roomType}', parsedArgs.roomType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::destroy
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:363
* @route '/room-types/{roomType}'
*/
destroy.delete = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::destroy
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:363
* @route '/room-types/{roomType}'
*/
const destroyForm = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomTypes\RoomTypeController::destroy
* @see app/Http/Controllers/Admin/RoomTypes/RoomTypeController.php:363
* @route '/room-types/{roomType}'
*/
destroyForm.delete = (args: { roomType: string | { id: string } } | [roomType: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const roomTypes = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    togglePause: Object.assign(togglePause, togglePause),
    destroy: Object.assign(destroy, destroy),
}

export default roomTypes